"use client"

import type { components } from "umbraco"
import Container from "../../Container"
import ContactChannelGlyph from "../../common/ContactChannelGlyph"
import { resolveChannels } from "../../common/contactChannels"
import { Root, Title, CardsRow, ChannelCard, ChannelLabel } from "./styles"

type ContactChannelsBlockData =
  components["schemas"]["ContactChannelsBlockPropertiesModel"]

interface Props {
  data: ContactChannelsBlockData
  settings?: Record<string, unknown> | null
  locale: string
  culture: string
  [key: string]: unknown
}

export default function ContactChannels({ data }: Props) {
  // "Show / Hide Component" toggle — hidden only when explicitly disabled.
  if (data.showComponent === false) return null

  const channels = resolveChannels(data)
  if (channels.length === 0) return null

  return (
    <Container paddingMobile>
      <Root data-component="contact-channels">
        {data.title && <Title variant="h3">{data.title}</Title>}
        <CardsRow>
          {channels.map((channel) => (
            <ChannelCard
              key={channel.key}
              href={channel.href}
              aria-label={channel.label || channel.channelType}
              {...(channel.external
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
            >
              <ContactChannelGlyph
                channelType={channel.channelType}
                iconUrl={channel.iconUrl}
                size={56}
              />
              <ChannelLabel variant="body1">{channel.label}</ChannelLabel>
            </ChannelCard>
          ))}
        </CardsRow>
      </Root>
    </Container>
  )
}
